import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import DesignKitchen from "./DesignKitchen.jsx";
import DnesPreview from "./DnesPreview.jsx";
import "./styles.css";
import "./tokens.css";

// v26.2 §2 — mark Android so CSS/JS can drop backdrop-filter (Mali/Chrome compositing bug).
if (typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent))
  document.documentElement.classList.add("android");

// Dev-only previews: #kitchen = primitive gallery, #dnes = new Dnes mock.
const h = window.location.hash;
const Root = h === "#kitchen" ? DesignKitchen : h === "#dnes" ? DnesPreview : App;

ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);

// v28.9 — po nasadení chceme novú verziu HNEĎ, nie až keď človek appku úplne zavrie.
// Prehliadač sám kontroluje service worker len pri navigácii (a raz za deň), takže mu to
// pripomenieme pri každom návrate do appky. Ak je vonku nový build, worker sa nainštaluje,
// aktivuje (skipWaiting) a v `activate` prekreslí otvorené okná — pozri src/sw.ts.
if ("serviceWorker" in navigator) {
  const checkForUpdate = () => {
    if (document.visibilityState !== "visible") return;
    navigator.serviceWorker.getRegistration().then((r) => r && r.update()).catch(() => { /* offline */ });
  };
  document.addEventListener("visibilitychange", checkForUpdate);
  window.addEventListener("focus", checkForUpdate);

  // v31 — druhá polovica opravy zo `sw.ts`: worker viditeľné okno už neprekresľuje, takže si
  // obnovu musí odriadiť stránka sama — ale až vtedy, keď sa človek NEPOZERÁ. Prekreslenie
  // pod rukami je presne to, čo na iPhone nechalo appku nekliknuteľnú.
  let pendingReload = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => { pendingReload = true; });
  document.addEventListener("visibilitychange", () => {
    if (pendingReload && document.visibilityState === "hidden") {
      pendingReload = false;
      location.reload();
    }
  });
}

// v31 — SAMOOZDRAVENIE pri otvorení appky. Odpoveď na „vie sa appka sama zotaviť?": áno.
// Keď po zaseknutom ťahu (alebo po čomkoľvek inom) ostanú na stránke stopy presúvania —
// trieda `bz-dragging` na body, plávajúci klon riadku, skrytý zdrojový riadok — obrazovka
// sa tvári nefunkčne a bielo. Doteraz to vyriešilo len zavretie a otvorenie appky. Teraz sa
// zvyšky upracú pri KAŽDOM návrate do appky, takže najhoršie, čo sa môže stať, je jedno
// nepodarené gesto namiesto rozbitej obrazovky. Beží mimo Reactu zámerne: musí to fungovať
// aj vtedy, keď je komponent v stave, ktorý sám seba neopraví.
function healStuckGestures() {
  if (document.visibilityState !== "visible") return;
  document.body.classList.remove("bz-dragging");
  document.querySelectorAll(".bz-drag-ghost").forEach((n) => n.remove());
  document.querySelectorAll(".bz-drag-src").forEach((n) => n.classList.remove("bz-drag-src"));
}
document.addEventListener("visibilitychange", healStuckGestures);
window.addEventListener("focus", healStuckGestures);
